import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import { formatDateTime, formatMoney } from './billingShared';

export default function TeacherBillingPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/payments/teacher/students/');
        if (!cancelled) setRows(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        if (!cancelled) setError(e.response?.data?.detail || 'Не удалось загрузить оплату учеников.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка…</p>
      </div>
    );
  }

  return (
    <div className="billing-page">
      <div className="page-header">
        <h1>Оплата учеников</h1>
        <p className="page-subtitle">
          Предоплата и долг по семейным счетам. Нажмите на ученика, чтобы увидеть историю и оформить занятие.
        </p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      {rows.length === 0 ? (
        <p className="text-secondary">Нет активных учеников.</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Ученик</th>
              <th>Ставка</th>
              <th>Предоплата / долг</th>
              <th>Последний платёж</th>
              <th>Всего внесено</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.student_id}>
                <td>
                  <Link to={`/teacher/billing/${row.student_id}`}>
                    {row.display_name || row.username}
                  </Link>
                </td>
                <td>{row.rate_per_hour ? formatMoney(row.rate_per_hour) : '—'}</td>
                <td className={row.status === 'debt' ? 'text-error' : 'text-success'}>
                  {row.status === 'debt'
                    ? `Долг ${formatMoney(row.debt)}`
                    : `Предоплата ${formatMoney(row.prepaid)}`}
                </td>
                <td>
                  {formatDateTime(row.last_payment_at)}
                  {row.last_payment_amount ? ` · ${formatMoney(row.last_payment_amount)}` : ''}
                </td>
                <td>{formatMoney(row.total_deposited)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
